import React, { useRef } from "react"

import { ActionIcon, TextInput } from "@mantine/core"
import { useClickOutside, useDisclosure, useUncontrolled } from "@mantine/hooks"
import { Icon } from "@/components"

import classes from "@/components/CollapsibleSearchInput/CollapsibleSearchInput.module.css"

export const CollapsibleSearchInput = ({ value, onChange, ...props }) => {
    const ref = useRef<HTMLInputElement>(null)
    const [_value, handleChange] = useUncontrolled<string>({
        value,
        onChange,
    })
    const [opened, handlers] = useDisclosure(false, {
        onOpen: () => ref.current.focus(),
    })
    const handleCollapse = () => {
        if (_value !== "") return
        handlers.close()
    }
    const refClickOutside = useClickOutside(handleCollapse)
    const ariaLabel = opened ? "Close search bar" : "Open search bar"
    return (
        <div ref={refClickOutside}>
            <TextInput
                classNames={{ ...classes }}
                {...props}
                value={_value}
                onKeyDown={(event) => (event.key === "Enter" ? handleChange(_value) : null)}
                onChange={(event) => handleChange(event.target.value)}
                data-collapsed={!opened}
                data-cy="collapsible-search-bar"
                placeholder={opened ? "Search" : ""}
                ref={ref}
                icon={
                    <ActionIcon
                        data-cy="search-bar-action-button"
                        onClick={handlers.open}
                        data-collapsed={!opened}
                        aria-label={ariaLabel}
                    >
                        <Icon icon="search" />
                    </ActionIcon>
                }
            />
        </div>
    )
}
